// @ts-check
import React from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';

const Loader = () => (
	<Skeleton
		variant="rounded"
		sx={(theme) => ({
			height: theme.size.xS,
			width: theme.size.xXL,
			margin: 200,
		})}
	/>
);

const TabBarLoader = ({ cells = 5 }) => {
	const tableCells = [];
	for (let i = 0; i < cells; i += 1) {
		tableCells.push(<Loader key={i} />);
	}

	return <Box sx={{ display: 'flex' }}>{tableCells}</Box>;
};

export default TabBarLoader;
